import { Box, BoxProps } from '@razorpay/blade/components';
import React, { PropsWithChildren } from 'react';

const ComponentContainer = ({ children, ...props }: PropsWithChildren<BoxProps>) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={'44px'}
      marginBottom={'spacing.8'}
      {...props}>
      {children}
    </Box>
  );
};

export const ComponentContainerWithBorder = ({
  children,
  ...props
}: PropsWithChildren<BoxProps>) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={'44px'}
      borderWidth="thin"
      borderColor="surface.border.gray.muted"
      borderRadius="medium"
      padding="spacing.7"
      {...props}>
      {children}
    </Box>
  );
};

export default ComponentContainer;
